import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

// Publishable key only — the secret key never reaches the browser.
export const supabase = url && key ? createClient(url, key) : null;
export const supabaseConfigured = Boolean(url && key);
